import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const ComoFunciona = () => {
  const [ref, isVisible] = useScrollAnimation();
  const pasos = [
    {
      titulo: 'Corroboramos Fotomultas',
      descripcion: 'Te generamos un informe con las fotomultas que tiene tu vehículo',
      icono: 'bi-search'
    },
    {
      titulo: 'Informe',
      descripcion:
        'En el informe te indicamos la situación jurídica de tus fotomultas y sobre ellas las que podemos trabajar para que no se conviertan en antecedentes, además generamos un presupuesto por los honorarios.',
      icono: 'bi-file-earmark-text'
    },
    {
      titulo: 'Autorización de gestión',
      descripcion:
        'Realizamos el contrato de servicios y el poder necesario para que nuestro equipo pueda representarte judicialmente.',
      icono: 'bi-credit-card'
    }
  ];

  return (
    <section id="como-funciona" className="bg-light" style={{ paddingTop: '3rem', paddingBottom: '6.5rem' }}>
      <div className="container" ref={ref}>
        <h2 className={`text-center mb-5 fw-bold titulo-seccion-desktop ${isVisible ? 'animate-fade-in' : ''}`}>¿Cómo funciona nuestro servicio?</h2>
        <div className="row g-4">
          {pasos.map((paso, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className={`card h-100 border-0 shadow-sm text-center p-4 ${isVisible ? 'animate-on-scroll' : ''} card-animate-${index + 1}`}>
                <div className="mb-3">
                  <i className={`bi ${paso.icono} text-primary`} style={{ fontSize: '3rem' }}></i>
                </div>
                <h4 className="card-title fw-bold">{paso.titulo}</h4>
                <p className="card-text text-muted">{paso.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
        {/* Sección de Honorarios */}
        <div className={`row mt-5 ${isVisible ? 'animate-fade-in' : ''}`} style={{ animationDelay: '0.5s' }}>
          <div className="col-lg-8 mx-auto">
            <div className="card border-0 shadow-sm p-4 text-center">
              <h4 className="fw-bold mb-3">Honorarios:</h4>
              <p className="mb-0" style={{ fontSize: '1.1rem' }}>
                Nuestros honorarios representan aproximadamente el 50% del valor de las fotomultas a gestionar
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComoFunciona;

